import { findSelectedProduct } from '../../helpers';
import { type BundleMachineGuard, type SelectionParams } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Whether an event comes from a selected product's customization machine.
 */
export const checkIfSelectedProductActor: BundleMachineGuard<SelectionParams> = (
  guardArgs,
  params,
) => {
  const { context } = guardArgs;
  const { selectionId } = params;

  const selectedProduct = findSelectedProduct({
    selectedProducts: context.selectedProducts,
    selectionId,
  });

  return selectedProduct !== undefined;
};
